// extracted by mini-css-extract-plugin
module.exports = {"btnTextStyle":"ComicMetaForm_btnTextStyle_13qm0","headingText":"ComicMetaForm_headingText_3UMSX"};